import { Routes, Route } from "react-router-dom";
import AdminDomainListScreen from "../pages/AdminDomainListScreen";
import AdminDomainPacksScreen from "../pages/AdminDomainPacksScreen";
import AdminCreateQuestionScreen from "../pages/AdminCreateQuestionScreen";
import AdminAllDomainQuestionsScreen from "../pages/AdminAllDomainQuestionsScreen";
import AdminAllInterviewsScreen from "../pages/AdminAllInterviewsScreen"
import AdminSelectInterviewQuestionScreen from "../pages/AdminSelectInterviewQuestionScreen"
import AdminQuestionCategoryList from "../pages/AdminQuestionCategoryList";
import AdminCategoryQuestionList from "../pages/AdminCategoryQuestionList";
import SelectInterviewQuestionCategory from "../pages/SelectInterviewQuestionCategory";
import AdminInterviewAllQuestionsScreen from "../pages/AdminInterviewAllQuestionsScreen";

export default function AdminRoutes() {
    return (
        <Routes>
            {/* /admin */}
            <Route
                index element={<AdminDomainListScreen />} 
                /> 
            <Route
                path="domain/:domainId"
                element={<AdminDomainPacksScreen />} />
            <Route
                path="domain/:domainId/all-questions"
                element={<AdminAllDomainQuestionsScreen />} />
            <Route
                path="domain/:domainId/:categoryId/create-question"
                element={<AdminCreateQuestionScreen />} />
            <Route
                path="domain/:domainId/:categoryId/create-question/:questionId"
                element={<AdminCreateQuestionScreen />} /> {/* ✅ Edit mode */}
            <Route
                path="domain/:domainId/pack/:packId/interviews"
                element={<AdminAllInterviewsScreen />} /> {/* ✅ New */}
            <Route
                path="domain/:domainId/:categoryId/pack/:packId/interview/:interviewId/"
                element={<AdminSelectInterviewQuestionScreen />}
            />
            <Route
                path="domain/:domainId/pack/:packId/interview/:interviewId/category"
                element={<SelectInterviewQuestionCategory />}
            />
            <Route
                path="domain/:domainId/QuestionCategories"
                element={<AdminQuestionCategoryList />} /> {/* ✅ New */}
            <Route
                path="domain/:domainId/category-questions/:categoryId"
                element={<AdminCategoryQuestionList />} /> {/* ✅ New */}
            <Route
                path="domain/interview-questions/:domainId/:packId/:interviewId"
                element={<AdminInterviewAllQuestionsScreen />} /> {/* ✅ New */}
        </Routes>
    );
}

